import React from 'react';
import ScanDocument from './ScanDocument';

const ScanPaper = (props) => <ScanDocument {...props} paper />;
export default ScanPaper;
